import React, { forwardRef } from "react";
import { useI18n } from "../../../i18n/i18n";
import { OptionBase } from "./shared/OptionBase";

export interface CreatableOptionProps extends Record<string, unknown> {
    inputValue: string;
    optionHeight: number;
}

export const CreatableOption = forwardRef<HTMLDivElement, CreatableOptionProps>(
    ({ inputValue, optionHeight, ...rest }, ref) => {
        const { i18n } = useI18n();
        return (
            <OptionBase height={optionHeight} {...rest} ref={ref}>
                {i18n._(
                    /*i18n*/ {
                        comment:
                            "When selected, this component will create a new option with the label 'inputValue' and add it to the list of options",
                        id: `Add "{inputValue}"`,
                        values: { inputValue },
                    }
                )}
            </OptionBase>
        );
    }
);

CreatableOption.displayName = "CreatableOption";
